<section class="blog-page">
    <div class="blog-page__header">
        <h1>{{'Blogs' | translate}}</h1>
        <p>{{'Explore our latest articles and updates.' | translate}}</p>
    </div>

    @if (isLoading) {
    <div class="blog-page__state">{{'Loading blogs...' | translate}}</div>
    } @else if (blogs.length === 0) {
    <div class="blog-page__state">{{'No blogs are available right now.' | translate}}</div>
    } @else {
    <div class="blog-page__grid">
        @for (blog of blogs; track blog.id) {
        <article class="blog-card">
            <div class="blog-card__body">
                <h2>{{ blog.title }}</h2>
                <div class="blog-card__summary" [innerHTML]="blog.summary || blog.content"></div>
            </div>
            <div class="blog-card__keywords">
                @for(keyword of blog.keywordArray; track keyword) {
                <a [routerLink]="['/', currentLang, 'blogs', keyword.replace(' ', '-')]" class="blog-card__keyword badge bg-secondary fs-6 me-1 my-1 p-2  text-decoration-none"><span>#{{ keyword }}</span></a>
                }
            </div>
            <div class="blog-card__footer">
                <a [routerLink]="['/', currentLang, 'post', blog.canonicalUrl]" target="_blank"
                    class="btn btn-primary">{{'Post details' | translate}}</a>
            </div>
        </article>
        }
    </div>

    @if (hasMoreItems) {
    <div class="blog-page__actions">
        <button type="button" class="load-more-btn" (click)="loadMoreBlogs()" [disabled]="isLoadingMore">
            {{ isLoadingMore ? ('Loading...' | translate) : ('Load more items' | translate) }}
        </button>
    </div>
    }
    }
</section>